
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class LayoutCol2 extends Vue {
  private name = 'LayoutCol2';
  @Prop()
  private classWrap!: string[];
}
